import React, { FC } from 'react'
import { useScreenClass } from 'react-grid-system'
import styled from 'styled-components'
import HERO from '../../assets/April2026Banner.svg'

const HeroContainer = styled.section<{ isDesktop: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${(props) => (props.isDesktop ? '2rem 1rem' : '2rem 1rem')};
  margin: 0 auto;
`

const BannerImage = styled.img<{ isDesktop: boolean }>`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: ${(props) => (props.isDesktop ? '900px' : '100%')};
  max-height: 600px;
  object-fit: contain;
`

const HeroButton = styled.a<{ size: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => (props.size === 'lg' ? '1rem 2.75rem' : '0.75rem 2rem')};
  border: 2px solid ${(props) => props.theme.colors.red};
  border-radius: 8px;
  background-color: white;
  color: ${(props) => props.theme.colors.red};
  font-size: ${(props) => (props.size === 'lg' ? '18px' : '14px')};
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-decoration: none;
  /* Positive margin keeps the button below the banner (no overlap) */
  margin-top: 1.5rem;

  &:hover {
    background-color: ${(props) => props.theme.colors.red};
    color: white;
    transform: scale(1.05);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 0, 0, 0.5);
  }

  &:active {
    transform: scale(0.95);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }
`

const Hero: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  return (
    <HeroContainer isDesktop={isDesktop}>
      <BannerImage src={HERO} alt="Job Banner" isDesktop={isDesktop} />
      <HeroButton
        href="https://stonybrook.zoom.us/meeting/register/J9m_CKJFRvaZnMdrkj9yBQ"
        size={isDesktop ? 'lg' : 'sm'}
        target="_blank"
        rel="noopener noreferrer"
      >
        CLICK HERE TO RSVP
      </HeroButton>
    </HeroContainer>
  )
}

export default Hero
